/*
 *             Copyright (c) 2016 - 2022, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
'use strict';var __importDefault=this&&this['__importDefault']||function(_0x18967f){return _0x18967f&&_0x18967f['__esModule']?_0x18967f:{'default':_0x18967f};};Object['defineProperty'](exports,'__esModule',{'value':!0x0});const descriptor_1=__importDefault(require('./descriptor'));class Message extends descriptor_1['default']{constructor(..._0x5510f8){super();}static['fromJSON'](_0x2d6a20){throw new TypeError('Must\x20be\x20implemented\x20in\x20a\x20child\x20class!');}}exports['default']=Message,Message['TYPE']='1000';